import React from 'react';

import WpIllustration from '../WpIllustration';
import { Illustrations } from '../illustrations.types';
import { WpContainer, WpContainerBody } from 'Wpds/components/container';

// Styles
import './IllustrationDocs.scss';

const IllustrationDocs = () => {
  const keys = Object.keys(Illustrations);

  const baseClassName = 'IllustrationDocs';

  return (
    <>
      <h5 className="mb-2">Illustrations</h5>
      <div className={baseClassName}>
        {keys.map(k => (
          <WpContainer className={`${baseClassName}__illustration`} key={k}>
            <WpContainerBody>
              <WpIllustration src={Illustrations[k]} className={`${baseClassName}__illustration__image`} />
              <p>{k}</p>
            </WpContainerBody>
          </WpContainer>
        ))}
      </div>
    </>
  );
};

export default IllustrationDocs;
